import { Request } from "express";

import { IParamBinder } from "./IParamBinder";

export class CookieParamParamBinder implements IParamBinder {
    private readonly key: string;

    public constructor(key: string) {
        this.key = key;
    }

    public extractValue(req: Request): unknown {
        return req.cookies[this.key];
    }
}
